import * as React from 'react';
const SvgEllipsisVerticalOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M13.969 7.666a1.5 1.5 0 0 0-3 0v.01a1.5 1.5 0 1 0 3 0zm-1.5 3.51a1.5 1.5 0 0 1 1.5 1.5v.01a1.5 1.5 0 0 1-3 0v-.01a1.5 1.5 0 0 1 1.5-1.5m0 5.01a1.5 1.5 0 0 1 1.5 1.5v.01a1.5 1.5 0 0 1-3 0v-.01a1.5 1.5 0 0 1 1.5-1.5"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgEllipsisVerticalOutlined;
